<forge-card *ngIf="!loading && hasData" class="processes no-padding">
    <div *ngFor="let item of list; let last = last">
        <processing-card [enableLink]="enableLink" [entity]="item"></processing-card>
        <forge-divider [ngClass]="{'last-child': last}"></forge-divider>
    </div>
</forge-card>